import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDataSourceList } from '../API/datasourcesApi';
import type { RootState } from '../store/store';

export interface IDataSource {
    id: string;
    displayName: string;
    description: string;
    name: string;
    dataSourceType: string;
    groupKey: string;
    pipelineKey: string;
    regions: string[];
    active: boolean;
    flag: boolean;
    tier: string;
    weight: number;
    taxonomies: string[];
    fullyQualifiedName: string;
    href: string;
    updatedAt: number;
    updatedBy: string;
    createdAt: number;
    version: number;
    deleted: boolean;
}

interface DataSourceState {
    dataSourceList: IDataSource[];
}

const initialState: DataSourceState = {
    dataSourceList: []
};

export const callGetDataSourceList = createAsyncThunk(
    'dataSources/getDataSourceList',
    async (args, { dispatch }) => {
        const response = await getDataSourceList();
        dispatch(setDataSourceList(response.data));
    }
);

export const dataSourceSlice = createSlice({
    name: 'dataSource',
    initialState,
    reducers: {
        setDataSourceList: (state, action: PayloadAction<IDataSource[]>) => {
            const removeDeletedSources = action.payload
                .filter(source => source.deleted !== true)
                .sort((a, b) => a.name.localeCompare(b.name));
            state.dataSourceList = removeDeletedSources;
        }
    }
});

export const { setDataSourceList } = dataSourceSlice.actions;

export const selectDataSourceList = (state: RootState): IDataSource[] => state.dataSource.dataSourceList;

export default dataSourceSlice.reducer;
